import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AnimatePresence } from 'framer-motion';
import Menu from './pages/Menu';
import CouponRedeem from './pages/CouponRedeem';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosUso from './pages/TermosUso';
import PaymentResultPage from './pages/PaymentResultPage';
import CookieConsent from './components/CookieConsent';
import theme from './theme';

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Menu />} />
        <Route path="/cardapio" element={<Menu />} />
        <Route path="/cupom" element={<CouponRedeem />} />
        <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
        <Route path="/termos-uso" element={<TermosUso />} />
        <Route path="/pagamento/:status" element={<PaymentResultPage />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AnimatedRoutes />
        <CookieConsent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
